import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import Layout from '@src/pages/layout'
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import FindMyOrder from '@src/quince-site-integrated/src/templates/Account/find-my-order'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { fetchSiteData } from '@src/server-side/api/fetch-site-data'
import { getUserAgnosticGlobalFeatureGates } from '@src/server-side/server-feature-flags/user-agnostic-global-feature-gates'
import { resolveCanaryGroupId } from '@src/server-side/utils/canary-group-id-header.utils'
import { getServerSideLocaleConfig } from '@src/server-side/utils/locale-config.server'
import { getTranslationsForPage, resolveLocaleData } from '@src/server-side/utils/locale.utils'
import { getParamsFromContext } from '@src/server-side/utils/request.utils'

export const getServerSideProps = (async ctx => {
  const [
    { deviceType, contentVersion, initialSearchParams },
    { locale, regionId, regionDetails, isI18nPreviewEnabled },
  ] = await Promise.all([getParamsFromContext(ctx), resolveLocaleData(ctx)])
  const canaryGroupId = resolveCanaryGroupId(ctx)

  const [userAgnosticGlobalFeatureGates, siteData, i18nProps, localeConfig] = await Promise.all([
    getUserAgnosticGlobalFeatureGates(isI18nPreviewEnabled, locale),
    fetchSiteData({
      contentVersion,
      device: deviceType,
      regionId,
      locale,
      isNewLocalisedFlow: isI18nPreviewEnabled,
      canaryGroupId,
    }),
    getTranslationsForPage(locale, PAGE_PATH.FIND_MY_ORDER),
    // Statsig-resolved locale config — consumed app-wide via LocaleConfigContext
    // (pageProps.localeConfig in _app); without it this page falls back to the
    // locale's static defaults.
    getServerSideLocaleConfig(locale),
  ])
  return {
    props: {
      ...i18nProps,
      pageData: null,
      regionDetails,
      locale,
      siteData,
      deviceType,
      contentVersion,
      searchParams: initialSearchParams,
      seoMetaData: null,
      pathName: PAGE_PATH.FIND_MY_ORDER,
      statsigProps: null,
      serverSideFeatureFlags: null,
      nonce: null,
      isI18nPreviewEnabled,
      userAgnosticGlobalFeatureGates,
      canaryGroupId,
      localeConfig,
    },
  }
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageFindMyOrder(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      <FindMyOrder />
    </Layout>
  )
}
